import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./MobileBottomNav.css";

const MobileBottomNav = () => {
  const location = useLocation();

  const linkClass = ({ isActive }) =>
    `mobile-bottom-link${isActive ? " active" : ""}`;

  const resetHome = (event) => {
    if (location.pathname === "/") {
      event.preventDefault();
      window.dispatchEvent(new CustomEvent("resetHomeToTop"));
    }
  };

  const resetCommunities = (event) => {
    if (location.pathname.startsWith("/communities")) {
      event.preventDefault();
      window.dispatchEvent(new CustomEvent("resetCommunitiesToGeneral"));
    }
  };

  return (
    <nav className="mobile-bottom-nav" aria-label="Primary navigation">
      <NavLink to="/" end className={linkClass} onClick={resetHome}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M3 10.5 12 3l9 7.5V21h-6v-7H9v7H3z" />
        </svg>
        <span>Home</span>
      </NavLink>

      <NavLink
        to="/communities"
        className={linkClass}
        onClick={resetCommunities}
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="8" cy="8" r="3" />
          <circle cx="16" cy="8" r="3" />
          <path d="M3 20c.4-4 2-6 5-6s4.6 2 5 6M11 20c.4-4 2-6 5-6s4.6 2 5 6" />
        </svg>
        <span>Communities</span>
      </NavLink>

      <NavLink to="/notifications" className={linkClass}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 9a6 6 0 0 1 12 0v5l2 3H4l2-3z" />
          <path d="M9.5 20h5" />
        </svg>
        <span>Alerts</span>
      </NavLink>

      <NavLink to="/profile" className={linkClass}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21c.5-5 3.2-7 8-7s7.5 2 8 7" />
        </svg>
        <span>Profile</span>
      </NavLink>

      <NavLink to="/settings" className={linkClass}>
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="3" />
          <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9 7 7M17 17l2.1 2.1M19.1 4.9 17 7M7 17l-2.1 2.1" />
        </svg>
        <span>Settings</span>
      </NavLink>
    </nav>
  );
};

export default MobileBottomNav;
